import { useState, useEffect } from "react";
import { getCustomerStats } from "../../backend-services";
import { CustomerStatsData } from "../../pages";

export function useCustomerStatsData(startDate: Date, endDate: Date) {
  const [customerStats, setCustomerStats] = useState<CustomerStatsData | null>(
    null,
  );
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    const start = startDate.toISOString();
    const end = endDate.toISOString();

    try {
      const response = await getCustomerStats(start, end);
     
      setCustomerStats(response);
      setError(null);
    } catch (error) {
      setError("Failed to fetch customer statistics");
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return { customerStats, error };
}
